export const APP_NAME = process.env.VUE_APP_APP_NAME;
export const LIVE_WS_URL = process.env.VUE_APP_LIVE_WS_URL;
export const LIVE_URL = process.env.VUE_APP_LIVE_URL;

export const DEV_URL = process.env.VUE_APP_DEV_URL;
export const DEV_WS_URL = process.env.VUE_APP_DEV_WS_URL;

export const APP_COUNTRY =  process.env.VUE_APP_COUNTRY
